import TeamsBaseComponent, {ITeamsBaseComponentState} from "msteams-react-base-component";
import React = require("react");
import {FilingLocation, SharedFile} from "../models";

export interface FileMetadataState extends ITeamsBaseComponentState {}

export interface FileMetadataProps {
    file: FilingLocation | SharedFile;
    isDeleted?: boolean;
}

export class FileMetadata extends TeamsBaseComponent<FileMetadataProps, FileMetadataState> {
    constructor(props: FileMetadataProps) {
        super(props);
    }

    public render() {
        const file = this.props.file;
        const documentNumber = file.Metadata["DocumentNumber"] ? `#${file.Metadata["DocumentNumber"]} | ` : "";
        const modifiedBy = file.Metadata["ModifiedBy"] ? `${file.Metadata["ModifiedBy"]} | ` : "";
        const modifiedDate = file.Metadata["Modified"]
            ? `${new Date(file.Metadata["Modified"]).toLocaleDateString()}`
            : "";

        const metadataString = `${documentNumber}${modifiedBy}${modifiedDate}`;

        return (
            <div className={this.props.isDeleted ? "deletedFileMetaData fileMetadata" : "fileMetadata"}>
                {metadataString && <span title={metadataString}>{metadataString}</span>}
            </div>
        );
    }
}
